import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  Stack,
  Alert,
  InputAdornment,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import postApiData from "../../../../hooks/apiRequests/postsRequest";
import { useToast } from "../../../shared/toastMessages/toastProvider";
import { theme } from "../../../../configs/theme";
import AuthCard, { authButtonSx, authFieldSx } from "../../common/authCard";

const ResendConfirmEmail = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setSubmitted(false);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      showToast("Please enter your email", "error");
      return;
    }

    setSubmitting(true);
    try {
      const response = await postApiData("/Send/ConfirmEmail", {
        email: trimmed,
      });
      if (!response?.error && (response?.status === 204 || response?.data)) {
        showToast(
          "If that account exists, a confirmation email has been sent.",
          "success"
        );
      } else {
        showToast("Unable to send confirmation email", "error");
      }
    } catch (error) {
      showToast("Unable to send confirmation email", "error");
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <AuthCard
      title="Resend confirm email"
      subtitle={
        submitted
          ? "Check your inbox for the confirmation link."
          : "Enter your email and we’ll resend your account confirmation link if needed."
      }
      footerTitle="Have an account?"
      footerActionLabel="Back to login"
      onFooterAction={() => navigate("/")}
    >
      {!submitted ? (
        <Stack component="form" spacing={2} onSubmit={handleSubmit}>
          <TextField
            id="email"
            label="Email"
            type="email"
            autoComplete="email"
            theme={theme}
            variant="outlined"
            size="small"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={authFieldSx}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlinedIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            theme={theme}
            disabled={submitting}
            fullWidth
            sx={authButtonSx}
          >
            {submitting ? "Sending..." : "Resend confirm email"}
          </Button>
        </Stack>
      ) : (
        <Stack spacing={2}>
          <Alert severity="success" sx={{ borderRadius: "10px" }}>
            If that account exists, a confirmation email has been sent. Please
            check your inbox.
          </Alert>
          <Button
            onClick={() => navigate("/")}
            variant="contained"
            theme={theme}
            fullWidth
            sx={authButtonSx}
          >
            Back to login
          </Button>
        </Stack>
      )}
    </AuthCard>
  );
};

export default ResendConfirmEmail;
